// React core
import React, { Component } from "react";
import { connect } from "react-redux";
// Components
//import { Cafeteria, Login, NavigationBar,PageContent,FoodList,SliderList,MainApp,Slider,Cart
//} from 'components';
import {
  MainApp,
  Cart,
  FastFood,
  Drinks,
  Snacks,
  NavigationBar3,
  Upload,
  Details,
  UploadedData,
  Upload2
} from "components";
import { Switch, Route, Redirect, Prompt } from "react-router-dom";
import { ApiService, EOSIOClient } from "services";

//import {FastFood,FastFoodList,Drinks,Snacks,DrinksList,SnacksList} from 'components'

class App extends Component {
  constructor(props) {
    super(props);
    this.eosio = new EOSIOClient("smartshop");
    localStorage.removeItem("account_name");
    this.state={
      tokenName:"EOS",
      contractName:"eosio.token"
    }
  }
  render() {
    //
    // Extract data from state and props (`user` is from redux)
    // Extract data from state and props ('user' is from redux)
    //const { user: { name } } = this.props;
    //const name= localStorage.getItem("cardgame_account")
    //console.log(name)
    // If the username is set in redux, display the Game component
    // If the username is NOT set in redux, display the Login component instead of MainApp I used Slider
    return (
      <React.Fragment>
        {/* { !name && <MainApp2 /> }
       { name && <MainApp /> } */}
        {/* {
        name && 
      console.log("I am name")
      }
      {!name &&
      console.log("Noooooooooooooo")
      } */}
        <NavigationBar3 eosio2={this.eosio} />

        <Switch>
          <Route exact path="/" component={MainApp} />

          {/* <Route strict path="/cart" component={Cart}/> */}

          <Route
            path="/cart"
            render={props => <Cart {...props} eosio2={this.eosio}  tokenName={this.state.tokenName} contractName={this.state.contractName} />}
          />

          <Route path="/fastFood" component={FastFood} />

          <Route path="/drinks" component={Drinks} />

          <Route path="/snacks" component={Snacks} />

          <Route
            path="/upload"
            render={props => <Upload {...props} eosio2={this.eosio}  tokenName={this.state.tokenName} contractName={this.state.contractName}/>}
          />

          <Route path="/uploadedData" 
          render={props => <UploadedData {...props} eosio2={this.eosio}  />}
          />

          <Route path="/details" component={Details} />

          <Route
            path="/upload2"
            render={props => <Upload2 {...props} eosio2={this.eosio} tokenName={this.state.tokenName} contractName={this.state.contractName}/>}
          />

          <Redirect path="/home" to="/" />
          <Prompt message="Are you sure you want to leave ?" />
        </Switch>
      </React.Fragment>
    );
  }
}

// Map all state to component props (for redux to connect)
const mapStateToProps = state => state;

// Export a redux connected component
export default connect(mapStateToProps)(App);
